import { Component, OnInit } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { RouterModule } from '@angular/router';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Platform } from '@ionic/angular/standalone';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { PwaPromptComponent } from './core/pwa/components/pwa-prompt/pwa-prompt.component';
import { PwaService } from './core/pwa/services/pwa.service';
import { PwaTriggerService } from './core/pwa/services/pwa-trigger.service';
import { PwaDemoService } from './core/pwa/services/pwa-demo.service';

@Component({
  selector: 'app-root',
  template: `
    <ion-app>
      <ion-router-outlet></ion-router-outlet>
      <app-pwa-prompt></app-pwa-prompt>
    </ion-app>
  `,
  standalone: true,
  imports: [IonApp, IonRouterOutlet, RouterModule, PwaPromptComponent]
})
export class AppComponent implements OnInit {
  constructor(
    private platform: Platform, 
    private router: Router,
    private pwaService: PwaService,
    private pwaTriggerService: PwaTriggerService,
    private pwaDemoService: PwaDemoService
  ) { 
    console.log('AppComponent: Constructor called');
    console.log('AppComponent: PWA Services injected:', {
      pwaService: !!this.pwaService,
      pwaTriggerService: !!this.pwaTriggerService,
      pwaDemoService: !!this.pwaDemoService
    });
  }

  ngOnInit() {
    this.initializeApp();
  }

  async initializeApp() {
    await this.platform.ready();

    if (Capacitor.isPluginAvailable('StatusBar') && Capacitor.getPlatform() === 'android') {
      // Configurar el StatusBar para Android
      StatusBar.setOverlaysWebView({ overlay: false });
      StatusBar.setBackgroundColor({ color: '#0d3017' });
      StatusBar.setStyle({ style: Style.Light });
    }

    // Manejar el botón de retroceso en Android
    if (Capacitor.getPlatform() === 'android') {
      App.addListener('backButton', ({ canGoBack }) => {
        // Rutas principales donde queremos minimizar la app al presionar atrás
        const mainRoutes = ['', '/', '/menu'];

        if (!canGoBack || mainRoutes.includes(this.router.url)) {
          // Si estamos en una página principal, minimizar la aplicación
          App.minimizeApp();
        } else {
          // En otras páginas, navegar hacia atrás
          window.history.back();
        }
      });
    }
    
    // Inicializar serviços PWA
    this.initializePwaServices();
    
    // Habilitar modo debug PWA em desenvolvimento
    this.enablePwaDebugMode();
  }
  
  private initializePwaServices(): void {
    console.log('AppComponent: Initializing PWA services...');
    
    try {
      // Inicializar o serviço de trigger PWA
      console.log('AppComponent: Calling pwaTriggerService.initialize()');
      this.pwaTriggerService.initialize();
      console.log('AppComponent: PWA services initialized successfully');
    } catch (error) {
      console.error('AppComponent: Error initializing PWA services:', error);
    }
  }
  
  private enablePwaDebugMode(): void {
    // Apenas em desenvolvimento
    if (!environment.production) {
      this.pwaDemoService.enableDebugMode();
    }
  }
}
